import React, { useEffect } from "react";
import PaymentMainDashboard from "../../../Components/PaymentLedger/PaymentMainDashboard/PaymentMainDashboard";
import { useDispatch, useSelector } from "react-redux";
import {
  walletAccount,
  walletContract,
  walletTransaction,
} from "../../../Redux/Slices/paymentSlice";

const PaymentLedger = () => {
  const dispatch = useDispatch();
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole
  )?.toLowerCase();
  const data = useSelector((state) => state?.persistedReducer?.user);
  const wallet = useSelector(
    (state) => state?.paymentSlice?.walletAccountActive
  );

  useEffect(() => {
    if (!role && !data) return;
    dispatch(
      walletAccount({
        role: role,
        id: data?.activeGeneratorId || data?.activeConsumerId,
      })
    );
  }, [dispatch, role, data?.activeGeneratorId, data?.activeConsumerId, data]);

  useEffect(() => {
    dispatch(walletTransaction());
    if (wallet?.id) {
      dispatch(walletContract({ id: wallet?.id }));
    }
  }, [dispatch, wallet?.id]);

  return (
    <div style={{ height: "100%" }}>
      <PaymentMainDashboard />
    </div>
  );
};

export default PaymentLedger;
